<tg-row
    class="motors-summary-page-validation-summary"
    *ngIf="firstInvalidStepTitle"
>
    <tg-col lg="6" sm="12">
        <tg-info-box tgStyle="danger">
            <tg-icon name="basic-info-framed" alt="information"> </tg-icon>
            <tg-info-box-heading>You've missed some things</tg-info-box-heading>
            Please fill required fields on the
            {{ invalidStepsMessage }} section.
            <tg-info-box-actions>
                <button tgButton2 transparent (click)="goToSection()">
                    Go to the {{ firstInvalidStepTitle }} section
                </button>
            </tg-info-box-actions>
        </tg-info-box>
    </tg-col>
</tg-row>
